import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  structureImage: "",
};

export const projectImage = createSlice({
  name: "ProjectImage",
  initialState: initialState,
  reducers: {
    updateProjectImg: (state, action) => {
      return { ...state, ...action.payload };
    },
  },
});

export const { updateProjectImg } = projectImage.actions;

export default projectImage.reducer;